import DefinitionsBody from "./definitionsBody";
import NavigationBar from "../../navigation/nav-bar/navigationBar";
import FooterComponent from "../../navigation/footer/footerComponent";

export default function MainDefinitions(props) {

    return (
        <div>
            <NavigationBar />
            <DefinitionsBody />
            <FooterComponent />
        </div>
    )
}